<!-- <p>visitor-summary works!</p> -->
<div class="demo-chart-wrapper">
  <div
    echarts
    [options]="option"
    [ngClass]="{
      'demo-chart':
        screenInfo == ScreenType.Desktop || screenInfo == ScreenType.Tablet,
      'demo-chart-mobile': screenInfo == ScreenType.Mobile
    }"
  ></div>
</div>
